import React, { useState } from "react";
import { resolveMediaUrl } from "@/lib/api";
import { ImageIcon } from "lucide-react";

const HUES = ["from-amber-100 via-rose-100 to-red-200", "from-sky-100 via-indigo-100 to-purple-200", "from-emerald-100 via-teal-100 to-cyan-200", "from-fuchsia-100 via-pink-100 to-rose-200"];
const hueFor = (s = "") => HUES[Math.abs([...s].reduce((a, c) => a + c.charCodeAt(0), 0)) % HUES.length];

/**
 * Blog cover image with graceful fallback.
 * If the URL fails to load, shows a category-tinted gradient with the title.
 */
export default function BlogCover({ src, title = "Article", category = "", className = "", rounded = false }) {
  const [broken, setBroken] = useState(false);
  const resolved = resolveMediaUrl(src);
  const gradient = hueFor(category || title);
  const wrapperCls = `relative w-full h-full bg-slate-100 ${rounded ? "rounded-xl overflow-hidden" : "overflow-hidden"} ${className}`;

  if (!resolved || broken) {
    return (
      <div className={`${wrapperCls} bg-gradient-to-br ${gradient} flex items-center justify-center`} data-testid="blog-cover-fallback">
        <div className="flex flex-col items-center gap-2 px-4 text-center">
          <ImageIcon className="w-8 h-8 text-slate-500/70" />
          <span className="text-[10px] font-mono-fin uppercase tracking-[0.25em] text-slate-600">{category || "Nivesh Street"}</span>
          <span className="text-sm font-heading font-bold text-slate-800 line-clamp-2 max-w-xs">{title}</span>
        </div>
      </div>
    );
  }
  return (
    <div className={wrapperCls}>
      <img
        src={resolved}
        alt={title}
        loading="lazy"
        onError={() => setBroken(true)}
        className="w-full h-full object-cover"
      />
    </div>
  );
}
